import _ from "lodash";
import state from "../state";

import { getResourceContentForResourceRef } from "./drive";

export const RESOURCE_TYPE_DRIVE = "resource/external/drive";
const DATASOURCE_TYPE = "datasource";

export function getDatasourceStateTreePathForRefId(refId) {
	let result = null;
	if (refId && !_.isEmpty(refId)) {
		const idx = getDatasourceIndexForRef(refId);
		if (_.isNumber(idx)) {
			result = ["activity", "externalResources", idx];
		} else {
			// Push a dud datasource so we can communicate error later
			if (state.exists(["activity", "externalResources"])) {
				state.push(["activity", "externalResources"], {
					id: refId,
					loadingFailure: "Referenced datasource does not exist, please contact the author of this activity to correct this issue."
				});
			} else {
				state.set(["activity", "externalResources"], [{
					id: refId,
					loadingFailure: "Referenced datasource does not exist, please contact the author of this activity to correct this issue."
				}]);
			}
			result = ["activity", "externalResources", state.get(["activity", "externalResources"]).length - 1];
		}
	}
	return result;
}

export function getDatasourceIndexForRef(refId) {
	let result = null;
	const currentActivity = state.get(["activity"]);
	if (currentActivity && _.isArray(currentActivity.externalResources)) {
		currentActivity.externalResources.forEach((externalResource, idx) => {
			if (isDatasource(externalResource)) {
				if (externalResource.id === refId) {
					result = idx;
				}
			}
		});
	}
	return result;
}


export function isDatasource(obj) {
	return isResourceEntry(obj) && obj.metaData && obj.metaData.subType === DATASOURCE_TYPE;
}

export function isResourceEntry(obj) {
	return obj && obj.type === RESOURCE_TYPE_DRIVE;
}


export function getDatasourceForRef(refId) {
	let result = null;
	const currentActivity = state.get(["activity"]);

	if (currentActivity && _.isArray(currentActivity.externalResources)) {
		currentActivity.externalResources.forEach(externalResource => {
			if (isDatasource(externalResource)) {
				if (externalResource.id === refId) {
					result = externalResource;
				}
			}
		});
	}

	return result;
}


export function retrieveDatasourceForRef(dsRef) {
	// // console.log("Retrieving data source for ref", dsRef);
	// const ds = getDatasourceForRef(dsRef);
	const path = getDatasourceStateTreePathForRefId(dsRef.refId);
	// // console.log("Got path for data source", path);
	if (path) {
		state.set(_.concat(path, ["loading"]), true);
		getResourceContentForResourceRef(null, dsRef, true).then(content => {
			state.set(_.concat(path, ["loading"]), false);
			state.set(_.concat(path, ["content"]), content);
		}).catch(err => {
			console.error("Failed to load data source", err);
			state.set(_.concat(path, ["loadingError"]), "Failed to load datasource. " + err);
			state.set(_.concat(path, ["loading"]), false);
		});
	} else if (dsRef.refId && !_.isEmpty(dsRef.refId)) {
		if (state.exists(["activity", "externalResources"])) {
			state.push(["activity", "externalResources"], {
				id: dsRef.refId,
				loadingFailure: "Referenced datasource does not exist, please contact the author of this activity to correct this issue."
			});
		} else {
			state.set(["activity", "externalResources"], [{
				id: dsRef.refId,
				loadingFailure: "Referenced datasource does not exist, please contact the author of this activity to correct this issue."
			}]);
		}
	}

}

export const RESOURCE_TYPE_EXTENRAL_UNMANAGED = "eternal/unmanaged";


export function getResourcesMap(activity) {
	let result = {};
	if (activity && activity.externalResources) {
		activity.externalResources.forEach(extResource => {
			result[extResource.id] = extResource;
		});
	}
	return result;
}

export function getResourceForResourceRef(activity, ref) {
	let result = ref;

	if (!activity) {
		activity = state.get(["activity"]);
	}

	if (_.isString(ref)) {
		result = {
			type: RESOURCE_TYPE_EXTENRAL_UNMANAGED,
			url: ref,
			revision: -1,
			guid: ref
		};
	} else if (activity && activity.externalResources) {
		const externalResourcesMap = getResourcesMap(activity);
		if (externalResourcesMap[ref.refId]) {
			result = externalResourcesMap[ref.refId];
		}
	}
	return result;
}


export function getDownloadRequestForResource(resource) {
	// console.log("Get download destination path (1)", resource);
	if (resource.revision && _.isNumber(resource.revision) && resource.url && resource.url.indexOf("v=") === -1) {

		const targetRevision = resource.cacheBustRevision ? resource.cacheBustRevision : resource.revision;

		if (resource.url.indexOf("?") !== -1) {
			resource.noCacheUrl = `${resource.url}&v=${targetRevision}`;
		} else {
			resource.noCacheUrl = `${resource.url}?v=${targetRevision}`;
		}
	}

	// // console.log("Get download destination path (2)", destination);
	return resource;
}
